const AWS = require("aws-sdk");
import AlbumFocus from "@/components/album-focus";

export default {
  props: ["albumInfo"],
  components: { AlbumFocus },
  data() {
    return {
      photos: [],
      focusIndex: null,
      lastFocusIndex: null,
      focusData: {
        lazy: null,
        full: null,
      },
      photosPerRow: 6,
      photosPerPage: 60,
      page: 0,
    };
  },
  mounted() {
    const photos = [];

    for (let i = 0; i < this.albumInfo.photos.length; i++) {
      photos.push([null, null]);
    }

    this.photos = photos;

    for (let i = 0; i < this.albumInfo.photos.length; i++) {
      const photo = this.albumInfo.photos[i];
      this.loadFile(photo, "thumbnail").then((imageData) => {
        this.$set(this.photos, i, [imageData, null]);
      });
    }
  },
  methods: {
    loadFile(photo, version) {
      return new Promise(async (resolve, reject) => {
        const s3 = new AWS.S3({
          credentials: {
            accessKeyId: this.albumInfo.credentials[photo.hostId].accessKey,
            secretAccessKey: this.albumInfo.credentials[photo.hostId].secretKey,
          },
          endpoint: this.albumInfo.hosts[photo.hostId].host,
          region: this.albumInfo.hosts[photo.hostId].region,
          s3ForcePathStyle: true,
        });

        const response = await s3
          .getObject({
            Bucket: this.albumInfo.hosts[photo.hostId].bucket,
            Key: photo.resource[version],
          })
          .promise().catch((reason) => {
            console.error({
              code: reason.code,
              message: reason.message,
              statusCode: reason.statusCode,
              requestId: reason.requestId,
              retryable: reason.retryable,
            });
            throw reason;
          });

        const imageData = response.Body;
        const contentType = response.ContentType;
        const base64 = Buffer.from(imageData).toString("base64");
        resolve(`data:${contentType};base64,` + base64);
      });
    },
    focus(index) {
      this.focusIndex = index;
      this.lastFocusIndex = index;
      this.page = Math.floor(index / this.photosPerPage);

      const fullsizeNotLoaded = this.photos[index][1] === null;

      if (fullsizeNotLoaded) {
        this.focusData.lazy = this.photos[index][0];
        this.focusData.full = null;

        this.loadFile(this.albumInfo.photos[index], "full")
          .then((imageData) => {
            this.photos[index][1] = imageData;
            this.focusData.full = this.photos[index][1];
          })
          .catch(() => {
            this.unfocus();
          });
      } else {
        this.focusData.full = this.photos[index][1];
      }
    },
    focusNext() {
      const index = this.focusIndex;

      if (index === this.photos.length - 1) {
        return;
      }

      this.focus(index + 1);
    },
    focusPrev() {
      const index = this.focusIndex;

      if (index === 0) {
        return;
      }

      this.focus(index - 1);
    },
    unfocus() {
      this.focusIndex = null;
    },
    download() {
      const photo = this.albumInfo.photos[this.focusIndex];
      let filePath = photo.resource.full.split(".");
      const extension = filePath.pop();
      const albumId = this.albumInfo.id;
      const baseName = filePath.pop().split("/").pop();
      const filename = `${albumId}_${baseName}.${extension}`;
      const downloadElement = document.createElement("a");
      downloadElement.href = this.photos[this.focusIndex][1];
      downloadElement.download = filename;
      downloadElement.click();
    },
  },
  computed: {
    displayedPhotos() {
      const start = this.photosPerPage * this.page;
      const end = start + this.photosPerPage;
      return this.photos.slice(start, end);
    },
    totalPages() {
      return Math.floor(this.photos.length / this.photosPerPage) + 1;
    },
  },
};
